import api from './axios';

const BASE = '/manufactures';

export const getManufactures = (page = 0, size = 10) =>
  api.get(BASE, { params: { page, size } });

export const getManufactureById = (id) => api.get(`${BASE}/${id}`);

export const createManufacture = (data) => api.post(BASE, data);

export const getManufactureCostPreview = (productId, quantity) =>
  api.get(`${BASE}/cost-preview`, { params: { productId, quantity } });
